import { ICurrencyService } from '../entities/ICurrencyService';
import { ICurrencyRepository } from '../entities/ICurrencyRepository';
import { Currency } from '../entities';

export class CurrencyServiceImpl implements ICurrencyService {
  itemRepo: ICurrencyRepository;

  constructor(ir: ICurrencyRepository) {
    this.itemRepo = ir;

    this.GetCurrencies = this.GetCurrencies.bind(this);
  }

  GetCurrencies(): Promise<Currency[]> {
    return this.itemRepo.GetCurrencies();
  }
}
